import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Header from "./Header";
import Sidebar from "./Sidebar";
import MobileBottomNav from "./MobileBottomNav";

const Layout = () => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const [open, setOpen] = useState(isMdUp);
  const toggleDrawer = () => {
    setOpen(!open);
  };
  useEffect(() => {
    setOpen(isMdUp);
  }, [isMdUp]);

  return (
    <Box sx={{ display: "flex" }}>
      <Header open={open} toggleDrawer={toggleDrawer} />
      <Sidebar open={open} toggleDrawer={toggleDrawer} />
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          flexGrow: 1,
          height: "100vh",
          overflow: "auto",
          p: 0.5,
          pt: 8.7,
          pl: 0.5,
          pb: { xs: 7, md: 0 },
          "& .MuiContainer-root": {
            ml: 0,
            mr: "auto",
          },
        }}
      >
        <Outlet />
      </Box>
      {!isMdUp && <MobileBottomNav />}
    </Box>
  );
};

export default Layout;
